import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "QuestionName",
    isNumber: true,
    isSum: true,
    isControl: true,
  },
  {
    key: "QuestionOptionName",
    isNumber: true,
  },
];

export const CareHealthCenterToExplainResult = {
  label: "照護衛生所 VS 判讀結果",
  key: "CareHealthCenterToExplainResult",
  path: "FundusAbnormal/CareHealthCenterToExplainResult",
  api: "TCS_V_EyesS02",
  render: (options) => (
    <Diagram.FundusAbnormal.CareHealthCenterToExplainResult {...options} />
  ),
  isColSum: true,
  isRowSum: true,
  isGroup: true,
  groupColumns: [
    {
      key: "HRegion",
      field: "HRegion",
      header: "",
    },
  ],
  levelColumns,
  columns: [],
};
